var map = {
	"./tile-brick.webp": 8582,
	"./tile-desert.webp": 9979,
	"./tile-grain.webp": 6650,
	"./tile-lumber.webp": 135,
	"./tile-ore.webp": 4045,
	"./tile-wool.webp": 8573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2728;